module.exports = __webpack_public_path__ + "media/NeueHaasUnicaW1G-Medium.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/NeueHaasUnicaW1G/NeueHaasUnicaW1G-Medium.ttf
// module id = 1575
// module chunks = 57